import { React } from 'react';
import profilePicture from '../assets/img/about/team_profile_picture.png';
import '../css/Profile.css';

const Profile = ({name, subject, email}) => {

    return (
        <div className='profile-container flex-center'>
            <div className='profile-left-pane flex-center'>
                <img 
                    className='profile-picture'
                    src={profilePicture}
                    alt='team-profile'
                />
            </div>
            <div className='profile-right-pane'>
                <div className='secondary-white-text palanquin-dark bold name ellipsis'>{name}</div>
                <div className='secondary-white-text outfit subject ellipsis'>{subject}</div>
                <a href={`mailto:${email}`}>
                    <div className='secondary-white-text outfit ellipsis email-text'>{email}</div>
                </a>
            </div>
        </div>
    );
};

export default Profile;
